import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Organisation } from 'app/core/organisation/organisation.types';

export enum OrganisationNameSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    XLARGE = 'xlarge'
}

@Component({
    selector: 'organisation-name',
    templateUrl: './organisation-name.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class OrganisationNameComponent {
    @Input() organisation: Organisation;
    @Input() showState: boolean = false;
    @Input() size: OrganisationNameSize = OrganisationNameSize.MEDIUM;
    @Input() withText: boolean = true;

    readonly OrganisationNameSize = OrganisationNameSize;

    get logoSize(): string {
        switch (this.size) {
            case OrganisationNameSize.SMALL:
                return 'w-6 h-6';
            case OrganisationNameSize.LARGE:
                return 'w-10 h-10';
            case OrganisationNameSize.XLARGE:
                return 'w-14 h-14';
            default:
                return 'w-8 h-8';
        }
    }

    get textSize(): string {
        switch (this.size) {
            case OrganisationNameSize.SMALL:
                return 'text-sm';
            case OrganisationNameSize.LARGE:
                return 'text-md';
            case OrganisationNameSize.XLARGE:
                return 'text-lg';
            default:
                return 'text-base';
        }
    }

    get logoTextSize(): string {
        switch (this.size) {
            case OrganisationNameSize.SMALL:
                return 'text-xs';
            case OrganisationNameSize.LARGE:
                return 'text-md';
            case OrganisationNameSize.XLARGE:
                return 'text-lg';
            default:
                return 'text-sm';       
        }
    }

    get borderRadius(): string {
        switch (this.size) {
            case OrganisationNameSize.SMALL:
                return 'rounded-md';
            case OrganisationNameSize.LARGE:
                return 'rounded-xl';
            case OrganisationNameSize.XLARGE:
                return 'rounded-2xl';
            default:
                return 'rounded-lg';
        }
    }
} 